"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteFile = void 0;
const common_1 = require("../../common");
const request_for_quote_header_model_1 = require("./request-for-quote-header.model");
class RequestForQuoteFile extends common_1.MongoDocument {
}
exports.RequestForQuoteFile = RequestForQuoteFile;
//# sourceMappingURL=request-for-quote-file.model.js.map